import Marquee from "react-fast-marquee";

const items = [
  "ALTA RISTORAZIONE",
  "CONSEGNA IN 24H",
  "VERONA E PROVINCIA",
  "FRESCHEZZA GARANTITA",
  "QUALITÀ PREMIUM",
  "FILIERA CORTA",
];

export default function BrandMarquee({ dark = false }) {
  return (
    <div
      data-testid="marquee"
      className={`py-6 border-y ${
        dark
          ? "bg-[#1A3322] border-[#F4F2EE]/10 text-[#F4F2EE]"
          : "bg-[#EAE7E1] border-[#1A3322]/10 text-[#1A3322]"
      }`}
    >
      <Marquee speed={45} gradient={false} autoFill>
        {items.map((t, i) => (
          <span key={i} className="mx-8 inline-flex items-center gap-8">
            <span className="font-serif-display text-3xl sm:text-4xl italic tracking-tight">{t}</span>
            <span className="text-[#C85A32] text-2xl">✳</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
